/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberShiftCancel200, PostApiBarberShiftCancel400, PostApiBarberShiftCancel401, PostApiBarberShiftCancel403, PostApiBarberShiftCancel404, PostApiBarberShiftCancel500, PostApiBarberShiftCancelMutationRequest, PostApiBarberShiftCancelMutationResponse } from "../entities/PostApiBarberShiftCancel";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsMessageResponseSchema } from "./models/messageResponseSchema";
import { modelsShiftCancelInputSchema } from "./models/shiftCancelInputSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const postApiBarberShiftCancel200Schema = z.lazy(() => modelsMessageResponseSchema) as unknown as z.ZodType<PostApiBarberShiftCancel200>

/**
 * @description Bad Request
 */
export const postApiBarberShiftCancel400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftCancel400>

/**
 * @description Unauthorized
 */
export const postApiBarberShiftCancel401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftCancel401>

/**
 * @description Forbidden
 */
export const postApiBarberShiftCancel403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftCancel403>

/**
 * @description Not Found
 */
export const postApiBarberShiftCancel404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftCancel404>

/**
 * @description Internal Server Error
 */
export const postApiBarberShiftCancel500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftCancel500>

/**
 * @description ID смены
 */
export const postApiBarberShiftCancelMutationRequestSchema = z.lazy(() => modelsShiftCancelInputSchema) as unknown as z.ZodType<PostApiBarberShiftCancelMutationRequest>

export const postApiBarberShiftCancelMutationResponseSchema = z.lazy(() => postApiBarberShiftCancel200Schema) as unknown as z.ZodType<PostApiBarberShiftCancelMutationResponse>